import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';
import { Model } from 'backbone';
import Storage from '../../../utils/Storage';
import _ from 'lodash';
import $ from "jquery";

export class RoundSlider extends View {
	get template() {
		return template;
	}

	get className() {
		return 'horizontal-slider';
	}

	ui() {
		return {
			inner: '.js-horizontal-slider-inner',
			item: '.js-item'
		}
	}

	events() {
		return {
			'click @ui.item': 'changeRound'
		}
	}

	initialize() {
		this.model = new Model({
			selected: 0,
			rounds: []
		});

		this.onResize = _.debounce(this.onResize.bind(this), 50);

		$(window).on('resize', this.onResize);

	}

	init({ rounds = [], selected }) {
		if (!selected) {
			selected = _.result(_.last(rounds), 'id', 1);
		}

		this.model.set({ rounds, selected });
		Storage.set('selected_round', selected);

		this.render();
	}

	changeRound({ currentTarget }) {
		const
			$element = $(currentTarget),
			selected = parseInt(currentTarget.dataset.id, 10);

		if (_.isEqual(selected, this.model.get('selected'))) {
			return false;
		}

		this.model.set({ selected });
		Storage.set('selected_round', selected);

		this.ui.item.removeClass('active');
		$element.addClass('active');

		this.triggerMethod('render');
		this.trigger('round:changed', selected);
	}

	onResize() {
		this.triggerMethod('render');

		return this;
	}

	onRender() {
		const
			initial_padding = this.$el.width() / 2,
			$selected_item = this.ui.inner.find('.active'),
			index = $selected_item.data('index'),
			item_width = $selected_item.width(),
			additional_padding = item_width * index - item_width / 2,
			diff = initial_padding - additional_padding,
			params = diff < 0 ? ({
				marginLeft: diff,
				paddingLeft: 0
			}) : ({
				marginLeft: 0,
				paddingLeft: initial_padding - additional_padding
			});

		this.ui.inner.css(params)
	}

	onBeforeDestroy() {
		$(window).off('resize', this.onResize);
	}
}

export default RoundSlider;